import { IoSearch } from "react-icons/io5";
import Logo from '../assets/images/logo.png';
import { FaChevronRight } from "react-icons/fa6";

const FooterComponent = () => {

    return (

        <footer className="footer" >

            <h4 className="footer_title" >Looking For Something Else?</h4>

            <div className="footer_search" >
                <IoSearch className="footer_search_ic" />
                <input className="footer_search_input" placeholder="Search Keyword" />
            </div>

            <h5 className="footer_fst" >Some features may not be available for all countries or all areas. View complete list.</h5>

            <ul>
                <li>The display has rounded corners that follow a beautiful curved design, and these corners are within a standard rectangle. When measured as a standard rectangular shape, the screen is 6.43 inches (LDX Air), 6.223 inches (LDX Premium), 6.71 inches (LDX Unicorn Pro), 5.5 inches (LDX Unicorn) diagonally. Actual viewable area is less.</li>
                <li>LDX Air and LDX Unicorn Pro can detect a severe car crash and call for help. Requires a cellular connection or Wi‑Fi calling.</li>
                <li>All battery claims depend on network configuration and many other factors; actual results will vary. Battery has limited recharge cycles and may eventually need to be replaced. Battery life and charge cycles vary by use and settings. See xceptia.network/ng/batteries and xceptia.network/iphone/battery.html for more information.</li>
                <li>Data plan required. 5G is available in select markets and through select carriers. Speeds vary based on site conditions and carrier. For details on 5G support, contact your carrier and see xceptia.network/iphone/cellular.</li>
            </ul>

            <div className="footer_div" >

                <div className="footer_div_top" >

                    <img src={Logo} alt="" className="footer_div_top_img" />

                    <FaChevronRight className="footer_div_top_ic" />

                    <h5 className="footer_div_top_txt" >Xceptia</h5>

                </div>

                <div className="footer_div_split" >

                    <div className="footer_div_split_div">
                        <h5>Explore</h5>
                        <h6>LDX Air</h6>
                        <h6>LDX Unicorn Pro</h6>
                        <h6>LDX Unicorn</h6>
                        <h6>LDX Premium</h6>
                        <h6>Smart Watches</h6>
                        <h6>Accessories</h6>
                    </div>

                    <div className="footer_div_split_div">
                        <h5>Account</h5>
                        <h6>Manage Your Xceptia ID</h6>
                        <h6>xCloud.com</h6>
                    </div>

                    <div className="footer_div_split_div">
                        <h5>About Xceptia</h5>
                        <h6>Company Info</h6>
                        <h6>Newsroom</h6>
                        <h6>Xceptia Leadership</h6>
                        <h6>Career Opportunities</h6>
                        <h6>Investors</h6>
                        <h6>Developer's Network</h6>
                        <h6>Ethics & Compliance</h6>
                    </div>

                    <div className="footer_div_split_div">
                        <h5>Xceptia Values</h5>
                        <h6>Privacy</h6>
                        <h6>Terms of use</h6>
                    </div>

                </div>

            </div>

            <h5 className="footer_retail" ><span>Find a retailer</span> near you!</h5>

            <div className="footer_copyRight" >

                <h5>Copyright © 2024 New Media Technologies. All rights reserved.</h5>

                <div>
                    <h4>Terms of Use</h4>
                    <h4>Site Map</h4>
                </div>

            </div>

        </footer>

    );

}

export default FooterComponent;